import jwtDecode from 'jwt-decode';

const auth = {
  isAuthorized({ permission, dispatch }) {
    // todo: if no token then notAuthorized
    // todo: if token but no access then forbidden (not doing this for boilerplate
    const allowed = this.getToken();

    if (allowed) {
      return true;
    }

    return false;
  },

  getToken() {
    const token = localStorage.getItem('token');

    return token;
  },

  setToken(token) {
    return localStorage.setItem('token', token);
  },

  removeToken() {
    return localStorage.removeItem('token');
  },

  getPayload() {
    const token = this.getToken();
    if (token) {
      const payload = jwtDecode(token);
      return payload;
    }
    return null;
  },
};

export default auth;
